<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
<div class="page-content-wrapper">
	<div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
		<ol class="breadcrumb bc-3"  >
			<li>
			  <a [routerLink]="'/home'">Home</a>
			</li>
			<li>
			  <a>Permit To Work</a>
			</li>
			
		  </ol>
		<div class="inner-wrapper">
			<div class="sub-wrapper">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item active" aria-current="page">
							Permit Overview
						</li>
						<li class="filter-sort">
							<div class="filter-sort-wrapper" (clickOutside)="onClickedOutside()">
								<a class="settings" data-toggle="collapse" data-target="#filter" (click)="onTabOpen()">
									<i class="fa fa-filter" aria-hidden="true" pTooltip="Filter" tooltipPosition="top"></i>
								</a>
								<div class="outer-wrapper" *ngIf="hideFilter">
									<ul class="filter-section-wrapper collapse" id="filter">
										<li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Unit </h5>
												<p-multiSelect [options]="unitList"  [(ngModel)]="selectedUnit"></p-multiSelect>
											</div>
										</li>
                    <li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Location </h5>
												<p-multiSelect [options]="locationList" [(ngModel)]="selectedLocation"></p-multiSelect>
											</div>
										</li>
                    <li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Permit Type </h5>
												<p-multiSelect [options]="permitTypes" [(ngModel)]="selectedPermitType"></p-multiSelect>
											</div>
										</li>
                    <div class="clearfix"></div>
										<li>
											<div class="leave-type">
												<h5>Expiry Date </h5>
												<div class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10">
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-left">
														<p-calendar [showIcon]="true" [maxDate]="currentDate" [showTime]="true" placeholder="From"
															dateFormat="dd/mm/yy" [(ngModel)]="ptwFromDate" class="custom-datepicker"
															readonlyInput="true" #timeOfUse="ngModel" monthNavigator="true"
															yearNavigator="true" yearRange="1950:2100" showButtonBar="true"></p-calendar>
													</div>
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-right">
														<p-calendar [showIcon]="true" [minDate]="ptwFromDate" [maxDate]="currentDate"
															dateFormat="dd/mm/yy" [showTime]="true" placeholder="To" [(ngModel)]="ptwToDate"
															class="custom-datepicker" readonlyInput="true" #timeOfUse="ngModel"
															monthNavigator="true" yearNavigator="true" yearRange="1950:2100" showButtonBar="true">
														</p-calendar>
													</div>
													<div class="clearfix"></div>
												</div>
												<div class="clearfix"></div>
											</div>
										</li>
										<div class="clearfix"></div>
										<li>
											<div class="leave-type">
												<h5>Status</h5>
												<p-multiSelect [options]="status" [(ngModel)]="selectedStatus"></p-multiSelect>
											</div>
										</li>
										<div class="clearfix"></div>
										<li class="filter-footer">
											<footer>
												<a (click)="resetFilter()" role="button" class="btn btn-primary primary-btn button-reset">
													<i class="fa fa-refresh"></i>Reset

												</a>
												<a (click)="doneFilter()" role="button" class="btn btn-primary primary-btn button-submit">
													<i class="fa fa-check"></i>Done
												</a>
											</footer>
										</li>
									</ul>
								</div>
								<a class="settings" data-toggle="collapse" data-target="#sort" (click)="onTabOpen()">
									<i class="fa fa-sort" aria-hidden="true" pTooltip="Sort" tooltipPosition="top"
										></i>
								</a>
								<div class="outer-wrapper" *ngIf="hideSort">
									<ul class="filter-section-wrapper sort-section-wrapper collapse" id="sort">
										<li>
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Permit No</label>
													<a class="">
														<i (click)="ascPtwNumber()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descPtwNumber()" class="fa fa-long-arrow-down" aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<li>
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Expiry Date</label>
													<a class="">
														<i (click)="ascPtwExpiryDate()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descPtwExpiryDate()"class="fa fa-long-arrow-down" aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<li class="no-margin-right">
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Name</label>
													<a class="">
														<i (click)="ascPtwName()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descPtwName()" class="fa fa-long-arrow-down" aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<div class="clearfix"></div>
									</ul>
								</div>
							</div>
							<div class="clearfix"></div>
						</li>
					</ol>
				</nav>
				<div class="section-wrapper">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
						<div class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10">
							<a [ngClass]="permitRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
								(click)="permitRecords.length ? exportToExcel() : $event.preventDefault()"
								class="btn btn-primary primary-btn button-excel" role="button">
								<i class="fa fa-file-excel-o" style="padding-right:10px"></i>
								<ng-container>Export To Excel</ng-container>
							</a>
							<a [ngClass]="permitRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'" (click)="downloadZIP()" class="btn btn-primary primary-btn button-zip" role="button">
								<i class="fa fa-file-zip-o" style="padding-right:10px"></i>
								<ng-container >Export To ZIP</ng-container>
							</a>
						</div>
						<div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right">
							<input type="text" placeholder="Search" class="form-control search-obs"  [(ngModel)]="searchText"
              (keyup.enter)="searchData()" />
							<button class="btn btn-primary primary-btn">
								<i class="fa fa-search search" (click)="searchData()" [class.padding]="searchText.length>0"></i>
                <i class="fa fa-close clear" *ngIf="searchText.length>0" (click)="clearSearch()"></i>
							</button>
						</div>
						<div class="clearfix"></div>
					</div>
					<div class="clearfix"></div>
					<div class="table-responsive margin-top-15  ">
						<table align="center" class="table table-bordered table-striped table-condensed">
							<thead>
								<tr>
									<th style="width: 20px">
										<input type="checkbox" [checked]="isPTWChecked"
                    (change)="selectAllPTWRequests($event.target.checked)" [(ngModel)]="isPTWChecked"
											[value]="isPTWChecked" >
									</th>
									<th style="width: 80px">Permit No</th>
									<th style="width: 140px">Activity Name</th>
									<th style="width: 80px">ContractNumber</th>
									<th style="width: 80px">ContractHolder Name</th>
									<th style="width: 80px">Location</th>
									<th style="width: 125px">Permit Type</th>
									<th style="width: 100px">Permit Applicant</th>
                  <th style="width: 100px">Permit Contractor</th>
									<th style="width: 100px">Expiry Date</th>
									<th style="width: 150px">Status</th>
									<th style="width: 20px">Download</th>
									
									<th style="width: 20px" *ngIf="independentPermissions.SUPER_Admin" >Action</th>
         	
								</tr>
							</thead>
							<tbody>
								<tr (contextmenu)="cm.show($event);showContextMenu(permitRecord)" #row style="cursor:pointer;"
									*ngFor='let permitRecord of permitRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'
									id={{permitRecord.permitId}}>
									<td>
										<span *ngIf="permitRecord.status ==='Draft'">
											<input type="checkbox" [disabled]="permitRecord.status==='Draft'"
											(change)="selectPermitRequests(permitRecord,$event)" [value]="permitRecord">
										</span>
										<span *ngIf="permitRecord.status!=='Draft'">
                                            <input type="checkbox" [(ngModel)]="permitRecord.Checked" [checked]="permitRecord.Checked"
                                            (change)="selectPermitRequests(permitRecord,$event)" [value]="permitRecord">
										</span>									
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
				                        <span *ngIf="permitRecord.status ==='Draft'" style="color:red">Draft</span>
				                        <span *ngIf="permitRecord.status!=='Draft'">{{permitRecord.permitNo}}</span>										
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.activityName}}
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.ContractNumber}}
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.ContractHolderName}}
									</td>

									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.location}}
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.permitType}}
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.name}}
									</td>
                  <td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.contractorName}}
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										<ng-container *ngIf="permitRecord.expiryDate">
                      {{permitRecord.expiryDate | dateTimeFormat: "MMM D, YYYY"}}
                    </ng-container>
                    <ng-container *ngIf="!permitRecord.expiryDate">
                      {{"NA"}}
                    </ng-container>
									</td>
									<td (click)="getCurrentDOMElementId(permitRecord.permitId)"
                  [routerLink]="['/ptw/raise-permit/', permitRecord.permitId,{unitId :permitRecord.unitId}]">
										{{permitRecord.status}}
									</td>
									<td (click)="downloadPDF(permitRecord.permitId)">
										<i class="fa fa-download"></i>
									</td>
									<td *ngIf="independentPermissions.SUPER_Admin">
										<ara-record-actions *ngIf="permitRecord.status === 'Deleted'" [SourceId]="permitRecord.permitId" ModuleName="PermitToWork" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >
					
										</ara-record-actions>
									  </td>
								</tr>
							</tbody>
						</table>
						<div style="width: 500px;margin-top:15px;color: red" *ngIf="(permitRecords.length == 0)">
							No Records Found
						</div>
						<div style="width: 500px" *ngIf="(permitRecords.length > 1)">
							<pagination-controls (pageChange)="getServerData($event)"></pagination-controls>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="clearfix"></div>
</div>
<p-contextMenu [appendTo]="row" [target]="row" #cm [model]="contextItems"></p-contextMenu>
